module.exports = __webpack_public_path__ + "img/login.417eff6c.png";